import React from 'react';
import { SearchDialogAnchor, SearchAnchorWrapper, AbsoluteContainer } from './search-anchor.styled';
export const SearchAnchor = ({
  children,
  onBlur,
  onFocus,
  onKeyDown,
  isExpanded
}) => /*#__PURE__*/React.createElement(SearchAnchorWrapper, null, /*#__PURE__*/React.createElement(AbsoluteContainer, {
  isExpanded: isExpanded
}, /*#__PURE__*/React.createElement(SearchDialogAnchor, {
  onBlur: onBlur,
  onFocus: onFocus,
  onKeyDown: onKeyDown,
  isExpanded: isExpanded
}, children)));